import React, { useState, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaBars, FaTimes } from 'react-icons/fa';
import './Navigation.css';

const Navigation = () => {
  const location = useLocation();
  const { t } = useTranslation();
  const [menuOpen, setMenuOpen] = useState(false);
  const logoImgRef = useRef(null);
  const spinAnimRef = useRef(null);

  const isActive = (path) => {
    return location.pathname === path;
  };

  const closeMenu = () => setMenuOpen(false);

  const handleLogoClick = () => {
    const img = logoImgRef.current;
    if (img && typeof img.animate === 'function') {
      if (spinAnimRef.current) {
        spinAnimRef.current.cancel();
      }
      spinAnimRef.current = img.animate(
        [
          { transform: 'perspective(800px) rotateY(0deg)' },
          { transform: 'perspective(800px) rotateY(360deg)' },
        ],
        {
          duration: 1100,
          easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
          iterations: 1,
        }
      );
    }
    setTimeout(() => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }, 100);
  };

  return (
    <nav className="navigation">
      <div className="nav-content">
        <div
          className="logo"
          onClick={handleLogoClick}
        >
          <img
            ref={logoImgRef}
            src="/images/process/futuroCodeMainLogoTS.png"
            alt="FuturoCode Logo"
          />
        </div>
        <div className="nav-links desktop-only">
          <Link 
            to="/" 
            className={`nav-link ${isActive('/') ? 'active' : ''}`}
          >
            {t('nav.home')}
          </Link>
          <Link 
            to="/about" 
            className={`nav-link ${isActive('/about') ? 'active' : ''}`}
          >
            {t('nav.about')}
          </Link>
          <Link 
            to="/services" 
            className={`nav-link ${isActive('/services') ? 'active' : ''}`}
          >
            {t('nav.services')}
          </Link>
          <Link 
            to="/start-project" 
            className={`nav-link cta-link ${isActive('/start-project') ? 'active' : ''}`}
          >
            {t('nav.startProject')}
          </Link>
        </div>
        <button className={`nav-menu-btn mobile-only ${menuOpen ? 'hidden' : ''}`} onClick={() => setMenuOpen(true)} aria-label="Open menu">
          <FaBars />
        </button>
      </div>
      {/* Mobile Menu Overlay */}
      {menuOpen && (
        <div className="mobile-menu-overlay">
          <button className="close-menu-btn" onClick={closeMenu} aria-label="Close menu">
            <FaTimes />
          </button>
          <div className="mobile-menu-links">
            <Link to="/" className={`nav-link ${isActive('/') ? 'active' : ''}`} onClick={closeMenu}>{t('nav.home')}</Link>
            <Link to="/about" className={`nav-link ${isActive('/about') ? 'active' : ''}`} onClick={closeMenu}>{t('nav.about')}</Link>
            <Link to="/services" className={`nav-link ${isActive('/services') ? 'active' : ''}`} onClick={closeMenu}>{t('nav.services')}</Link>
            <Link to="/start-project" className={`nav-link cta-link ${isActive('/start-project') ? 'active' : ''}`} onClick={closeMenu}>
              {t('nav.startProject')}
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navigation; 